import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    level?: 'h1' | 'h2' | 'h3' | 'h4';
    className?: string;
    children: ReactNode;
}

export function Heading({ level = 'h1', className, children }: Props) {
    if (level === 'h1') {
        return <h1 className={twMerge('text-3xl font-medium text-neutral-700', className)}>{children}</h1>;
    }

    if (level === 'h2') {
        return <h2 className={twMerge('text-2xl font-medium text-neutral-700', className)}>{children}</h2>;
    }

    if (level === 'h3') {
        return <h3 className={twMerge('text-lg font-medium text-neutral-700', className)}>{children}</h3>;
    }

    if (level === 'h4') {
        return <h4 className={twMerge('text-md font-medium text-neutral-700', className)}>{children}</h4>;
    }
}
